/**
 * The one place where App Studio reads who an App and its pages are for.
 *
 * The answer follows the page rights: who may open each page decides the
 * page badge. Callers only render the answer. Pinned by __tests__/studio-access-read-model.spec.ts.
 */
import {
  type AppPageAccessSection,
  appPageKind,
} from '@streamlain/view-config';

/** Who reaches one page of an App. */
export type StudioPageAudience = 'internal' | 'portal' | 'public';

export const STUDIO_PAGE_AUDIENCE_LABEL_KEYS = {
  internal: 'com.streamlain.appBases.access.internal',
  portal: 'com.streamlain.appBases.access.portal',
  public: 'com.streamlain.appBases.access.public',
} as const satisfies Record<StudioPageAudience, string>;

/** Page list badge and page editor: the kind of the page, a form as public. */
export function pageAudienceForAccess(
  section: AppPageAccessSection | undefined,
  path: string
): StudioPageAudience {
  const kind = appPageKind(section, path);
  return kind === 'publicForm' ? 'public' : kind;
}
